// extracted by mini-css-extract-plugin
export var container = "_59-0";
export var error = "_59-9";
export var label = "_59-5";
export var light = "_59-6";
export var md = "_59-3";
export var sm = "_59-2";
export var thin = "_59-8";
export var thinBold = "_59-7";
export var vertical = "_59-4";
export var xs = "_59-1";